import { render, staticRenderFns } from "./rutaForm.vue?vue&type=template&id=ae007bfa"
import script from "./rutaForm.vue?vue&type=script&lang=js"
export * from "./rutaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports